import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * parseFR — Parse a French locale number safely.
 * Accepts:
 *   - "12,45"   → 12.45  (comma decimal separator)
 *   - "1 250,5" → 1250.5 (space thousand separator)
 *   - "12.45"   → 12.45
 *   - ""/null   → 0
 * Returns 0 on invalid input (never NaN).
 */
export function parseFR(v) {
  if (v === null || v === undefined || v === '') return 0;
  const s = String(v).replace(/\s/g, '').replace(',', '.');
  const n = parseFloat(s);
  return Number.isNaN(n) ? 0 : n;
}
